import React from "react";
import "./FamilyTrip.css";
import HillStationRetreat from "../../assets/HillStationRetreat.png";
import BeachsideFamilyEscape from "../../assets/BeachsideFamilyEscape.png";
import ThemeParkAdventure from "../../assets/ThemeParkAdventure.png"
import CulturalHeritageTour from "../../assets/CulturalHeritageTour.png"
import WildlifeNatureTrip from "../../assets/WildlifeNatureTrip.png";
import CountrysideFarmStay from "../../assets/CountrysideFarmStay.png";
import { useNavigate } from "react-router-dom";
const familyTrips = [
  {
    title: "Hill Station Retreat",
    img: HillStationRetreat,
    description:
      "Enjoy a refreshing hill station vacation with cool weather, scenic mountain views, and peaceful surroundings. Spend quality time exploring nature trails, boating on serene lakes, and enjoying cozy evenings together. Perfect for families seeking relaxation and bonding.",
    link: "/tour-package-data",
  },
  {
    title: "Theme Park Adventure",
    img: ThemeParkAdventure,
    description:
      "Experience thrilling rides, exciting attractions, and fun filled entertainment at a popular theme park. Share laughter on roller coasters, enjoy live shows, and indulge in delicious treats. A joyful getaway designed for unforgettable family moments.",
    link: "/tour-package-data",
  },
  {
    title: "Beachside Family Escape",
    img: BeachsideFamilyEscape,
    description:
      "Relax on sandy beaches while children build sandcastles and adults unwind by the waves. Enjoy swimming, beach games, and sunset walks along the shore. A delightful seaside retreat offering fun, relaxation, and precious family memories.",
    link: "/tour-package-data",
  },
  {
    title: "Cultural Heritage Tour",
    img: CulturalHeritageTour,
    description:
      "Explore historical landmarks, ancient monuments, and vibrant local traditions together. Learn fascinating stories, taste regional cuisine, and experience cultural festivals. An educational and enriching journey that strengthens family connections through shared discoveries.",
    link: "/tour-package-data",
  },
  {
    title: "Wildlife Nature Trip",
    img: WildlifeNatureTrip,
    description:
      "Discover wildlife reserves and scenic forests while spotting fascinating animals in their natural habitat. Enjoy guided safaris, nature walks, and peaceful surroundings. A memorable family adventure combining learning, excitement, and appreciation for nature.",
    link: "/tour-package-data",
  },
  {
    title: "Countryside Farm Stay",
    img: CountrysideFarmStay,
    description:
      "Experience rural life with farm activities, fresh air, and open green landscapes. Participate in fruit picking, animal feeding, and relaxing outdoor games. A peaceful getaway offering simple pleasures and meaningful family bonding time.",
    link: "/tour-package-data",
  },
];

const FamilyTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="family-container">
      <h2 className="family-title">Family Trip Packages</h2>

      <div className="family-grid">
        {familyTrips.map((trip, index) => (
          <div
            className="family-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.img} alt={trip.title} />
            <div className="family-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FamilyTrip;
